<template>
  <v-app class="container">
    <br />
    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left" background-color="blue-grey lighten-4" horizontal>
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        <v-icon left>show_chart</v-icon>Avance
      </v-tab>
      <v-tab>
        <v-icon left>folder</v-icon>Ficha Técnica
      </v-tab>
      <v-tab >
        <v-icon left>attach_file</v-icon>Documentos Relacionados
      </v-tab>
      <v-tab-item>
        <v-card :disabled="loading" :loading="loading" flat>
          <v-card-title>
            <p v-if="gindicador != null">{{gindicador.codigo}} {{gindicador.nombre}}</p>
          </v-card-title>
          <v-card-text>
            <v-radio-group row v-model="visualizacion">
              <v-radio v-for="n in botones" :key="n.id" :label="`${n.caption}`" :value="n.id"></v-radio>
            </v-radio-group>
            <div style="width:100%; height:400px" id="chartdiv"></div>
            <v-flex xs12 sm12>
                <v-alert v-if="tienerezago & indicadorfinalizado == false" border="left" colored-border dense color="blue darken-1" elevation="2"  type="info" >
                <p class="font-weight-light"> Este indicador continúa en seguimiento por rezago en el cumplimiento de su meta global.
                  </p>
                </v-alert>
                <v-alert v-if="tienerezago & indicadorfinalizado" border="left" colored-border dense color="blue darken-1" elevation="2"  type="info" >
                <p class="font-weight-light"> Este indicador continúa en seguimiento porque sigue existiendo su atributo de medición.
                  </p>
                </v-alert>                              
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 sm6>
                  <v-btn color="primary" @click="pdfcomparativo">Exportar</v-btn>
              </v-flex>
              <v-flex xs12 sm6 style="text-align: end;"  v-if="idrol == 1 || idrol == 3">
                  <v-btn color="primary" @click="recalcularMetas">Re-Calcular</v-btn>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="headers"
              :items="metasvigencia"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              hide-default-footer
              :items-per-page="50"
              show-expand
              class="elevation-1"
              item-key="periodo"
              :no-data-text="gnodata" 
              >
              <template v-slot:[`item.extemporaneo`]="{ item }">
                <div v-if="item.extemporaneo == true">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mr-2" v-on="on"> fa-clock </v-icon>
                    </template>
                    <span v-if="tienerezago && indicadorfinalizado == false">Avance rezagado</span>
                    <span v-if="tienerezago && indicadorfinalizado">Posterior a vigencia PMI</span>
                  </v-tooltip>
                </div>
              </template>              
              <template v-slot:[`item.valor`]="{ item }">
                <div v-if="item.valor === null">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="mr-2">-</span>
                    </template>
                    <span>La entidad no definió meta</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  <span small class="mr-2">{{cambiardecimal(item.valor)}}</span>
                </div>
              </template>
              <template v-slot:[`item.reporte`]="{ item }">
                <div v-if="item.reporte !== null && tieneAvance(item.avanceCuantitativo)">
                  <span small class="mr-2">{{!tieneAvance(item.avanceCuantitativo) ? "-" : cambiardecimal(item.reporte)}}</span>
                </div>
                <div v-else>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-if="item.vencido === true" v-on="on" class="mr-2">-</span>
                      <span v-else class="mr-2"></span>
                    </template>
                    <span v-if="item.valor !== 0 && item.valor !== null">Entidad no registró avance</span>
                    <span v-else-if="item.valor === null">La entidad no definió meta</span>
                    <span
                      v-else
                    >Entidad definió meta 0 o por aspectos técnicos no se midió el indicador</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:[`item.avancetexto`]="{ item }">
                <div v-if="item.avance !== null">
                  <span small class="mr-2">{{item.avancetexto}}</span>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-if="item.vencido === true" v-on="on" class="mr-2">-</span>
                      <span v-else class="mr-2"></span>
                    </template>
                    <span v-if="(item.valor !== 0 && item.valor !== null) || (item.avancetexto=='' && item.vencido)">Entidad no registró avance</span>
                    <span v-else-if="item.valor === null">La entidad no definió meta</span>
                    <span v-else-if="item.valor === 0">Entidad definió meta 0 o por aspectos técnicos no se midió el indicador</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:expanded-item="props1" style="width:100%">
                <td colspan="7">
                  <v-data-table
                    :headers="subheaders"
                    :items="props1.item.avanceCuantitativo.filter(p=> p.finalizado===true)"
                    hide-default-footer
                    class="elevation-1"
                    item-key="periodo"
                    :items-per-page="12"
                    :no-data-text="gnodata"
                  >
                    <template v-slot:[`item.valor`]="{ item }">
                      <span small class="mr-2">{{cambiardecimal(item.valor)}}</span>
                    </template>
                    <template v-slot:[`item.reporte`]="{ item }">
                      <span small class="mr-2">{{cambiardecimal(item.reporte)}}</span>
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
            <div v-if="ultimoavance">
              <br />
              <h6>Avance cualitativo del indicador</h6>
              <p class="aclaratoria">{{formato(ultimoavance.fechacorte)}}</p>
              <p class="aclaratoria" v-html="ultimoavance.descripcion"></p>
              <v-dialog v-model="dialog" width="800">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" v-on="on">Ver historico</v-btn>
                </template>
                <v-card>
                  <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                  >Avance cualitativo del indicador</v-card-title>
                  <v-card-text>
                    <v-container>
                    <div v-for="(item, index) in gavancecualitativohistoric" :key="index">
                      <p class="aclaratoria">{{formato(item.fechacorte)}}</p>
                      <p class="aclaratoria">
                        <v-layout row wrap>

                          <v-flex xs12 sm12 v-if="idrol == 1 || idrol == 2 || idrol == 3">
                            <v-flex xs12 sm12 v-if="item.principalavance != null">
                              <div class="text-semibold">
                                Principales avances en función del cumplimiento de la meta del indicador
                              </div>
                              <div v-html="item.principalavance"></div>
                              <br>
                            </v-flex>
                          </v-flex>

                          <v-flex xs12 sm12 v-if="item.descripcion != null">
                            <div class="text-semibold">
                              Justificación del avance
                            </div>
                            <div v-html="item.descripcion"></div>
                          </v-flex>
                          <v-flex xs12 sm12 v-if="idrol == 1 || idrol == 2 || idrol == 3">                            
                            <v-flex xs12 sm12 v-if="item.avancesReestricciones.length > 0">
                              <div class="text-semibold">
                              Restricciones
                              </div>                              
                              <ul v-for="(item1, index1) in item.avancesReestricciones" :key="index1">
                                <li class="aclaratoria">{{item1.nombreRestriccion}}
                                  <div style="display: inline;" v-if="item1.nombreRestriccion == 'Otra'">({{ item.nuevareestriccion }})</div>
                                </li>
                              </ul>
                            </v-flex>
                            <v-flex xs12 sm12 v-if="item.cuellobotella != null">
                              <div class="text-semibold">
                                Cuellos de botella y limitaciones que afectaron el desempeño del indicador
                              </div>
                              <div v-html="item.cuellobotella"></div>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12>
                            <hr>
                          </v-flex>
                        </v-layout>                        
                      </p>
                    </div>
                  </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" text @click="pdfavance()">Exportar</v-btn>
                    <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <div v-if="verhitos">
              <v-card flat>
              <v-card-title>
                  <p v-if="gindicador != null">Hitos {{gindicador.codigo}} - Avance de gestión {{this.avancegestion}}</p>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12 sm12>
                    <v-data-table
                      :headers="HeaderHitos"
                      :items="ghito"
                      :items-per-page="100"
                      class="elevation-1"
                      hide-default-footer
                      :no-data-text="gnodata"
                    >
                      <template
                        v-slot:[`item.fechacumplimiento`]="{ item }"
                      >{{formato(item.fechacumplimiento)}}</template>
                      <template v-slot:[`item.cumplido`]="{ item }">
                        <div v-if="item.cumplido === true && item.idestado == 6">Sí</div>
                        <div v-else>No</div>
                      </template>
                      <template v-slot:[`item.fechamodificacion`]="{ item }">
                        <div v-if="item.cumplido === true">{{formato(item.fechamodificacion)}}</div>
                        <div v-else>NA</div>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <div v-if="item.idestado == 6 || (item.cumplido === false && item.hitoaprobado)">
                          <v-icon small class="mr-2" @click="verdetallehito(item)">remove_red_eye</v-icon>
                        </div>
                        <div v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon small color="red" class="mr-2" v-on="on">mdi-eye</v-icon>
                            </template>
                            <span>No se cuenta con detalle del hito</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-title>
            <p v-if="gindicador != null">{{gindicador.codigo}} {{gindicador.nombre}}</p>
          </v-card-title>
          <v-card-text>
            <v-container fluid v-if="valPunto">
              <v-btn color="primary" @click="pdfficha">Exportar</v-btn>
              
              <v-row>
                <v-col xs12 sm12>
                  <!--<v-text-field
                      v-model="tipoclasificadorNavigation.nombre" 
                      label="Instrumento de planeación:"
                      readonly
                  ></v-text-field>-->
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-text-field v-model="valPunto.punto.nombre" label="Punto:" :readonly="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12 sm12>
                  <v-text-field
                    v-model="valPunto.pilar.nombrecompleto"
                    label="Pilar:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-text-field
                    v-model="valPunto.estrategia.nombrecompleto"
                    label="Estrategia:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-textarea
                    v-model="valPunto.linea.nombrecompleto"
                    label="Línea de acción:"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-textarea
                    v-model="valPunto.idproductoNavigation.nombrecompleto"
                    label="Producto:"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="valPunto.inicio" label="Fecha inicio:" :readonly="true"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="valPunto.fin" label="Fecha fin:" :readonly="true"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm6>
                  <v-text-field v-model="valPunto.sectores.nombre" label="Sector:" :readonly="true"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm6>
                  <v-text-field
                    v-model="valPunto.entidades.nombre"
                    label="Entidad responsable:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-text-field
                    v-model="valPunto.idclasificacionNavigation.nombre"
                    label="Clasificador PMI:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-textarea
                    height="200px"
                    :readonly="true"
                    v-model="valPunto.descripcion"
                    label="Descripción:"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea
                    :readonly="true"
                    v-model="valPunto.formulacalculo"
                    label="Fórmula de cálculo:"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="unidad" label="Unidad de medida:" :readonly="true"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="periodicidad"
                    label="Periodicidad de actualización:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :readonly="true"
                    v-model="valPunto.diasrezago"
                    label="Días de rezago:"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col xs12 sm12>
                  <v-textarea
                    :readonly="true"
                    v-model="valPunto.metodologiamedicion"
                    label="Metodología de medición:"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="valPunto.lineabase === null ">
                <v-col xs12 sm12>
                  <v-textarea
                    v-model="valPunto.comentariolineabase"
                    label="Argumento de porque no tiene línea base:"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="6">
                  <v-text-field v-model="valPunto.lineabase" label="Línea base:" :readonly="true"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :value="formato(valPunto.fechabase)"
                    label="Fecha de línea base:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>


                  <v-card>
                    <v-card-title>
                      Metas
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetas"
                          :items="MetasVigenciasinext.filter(p=>  p.idestado == 6 )"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        >
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetasCuatrenio"
                          :items="MetasCuatrenio"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        ></v-data-table>
                      </v-flex>
                      <v-flex xs12 sm2 class="col-padd">
                        <v-text-field
                          readonly
                          v-model="valPunto.meta"
                          label="Meta global"
                        ></v-text-field>


                      </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-card-title>
                      
                      Avance rezagado o posterior a la vigencia PMI
                    </v-card-title>
                    
                    <v-card-text>
                      <v-layout row wrap>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetas"
                          :items="MetasVigenciaext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        >
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetasCuatrenio"
                          :items="MetasCuatrenioext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        ></v-data-table>                      
                      </v-flex>
                      <v-flex xs12 sm2 class="col-padd">
                      </v-flex>   
                      </v-layout>                      
                    </v-card-text>
                  </v-card> 




              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="tipoacumulacion"
                    label="Tipo acumulación:"
                    :readonly="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="tipoindicador" label="Tipo de indicador:" :readonly="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  Territorialización de indicador:
                  <v-radio-group row v-model="valPunto.territorialindicador" :readonly="true">
                    <v-radio label="si" :value="true"></v-radio>
                    <v-radio label="no" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="4">
                  Desagregación poblacional por sexo:
                  <v-radio-group row v-model="valPunto.desagregacionpoblacional" :readonly="true">
                    <v-radio label="si" :value="true"></v-radio>
                    <v-radio label="no" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="4">
                  Pertenencia étnica:
                  <v-radio-group row v-model="valPunto.pertenenciaetnica" :readonly="true">
                    <v-radio label="si" :value="true"></v-radio>
                    <v-radio label="no" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="valPunto.territorialindicador">
                <v-col cols="12" md="12">
                  <v-select
                    :readonly="true"
                    :items="gterritorializaciones"
                    v-model="territorializacionselect"
                    item-text="nombre"
                    item-value="idterritorializacion"
                    label="Territorialización"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="valPunto.fuenteinformacion"
                    label="Fuentes de información:"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-select
                    :readonly="true"
                    v-model="responsableselected"
                    :items="gentidades"
                    item-text="nombre"
                    item-value="identidad"
                    label="Responsable PMI:"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-select
                    :readonly="true"
                    v-model="entidadselected"
                    :items="gentidades"
                    item-text="nombre"
                    item-value="identidad"
                    label="Entidades involucradas:"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="valPunto.observacionadicional"
                    label="Observaciones:"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="valPunto.metastrazadoras"
                    label="Metas trazadoras:"
                    v-show="clasificacionetnico"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="valPunto.observacionetnicos"
                    label="Observaciones étnico:"
                    v-show="clasificacionetnico"
                    :readonly="true"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item >
        <v-card>
          <v-card-title>
            <p v-if="gindicador != null">{{gindicador.codigo}} {{gindicador.nombre}}</p>
          </v-card-title>
        </v-card>
        <v-card>
          <v-card-title class="grey lighten-4 change-font">Soportes - Avance cuantitativo</v-card-title>

          <v-card-text>
            <br />
            <v-data-table
              :headers="showHeadersSCuanti"
              :items="gsoportescuantitativosOK"
              class="elevation-1"
              :items-per-page="5"
              :no-data-text="gnodata"
            >
            <template v-slot:[`item.publico`]="{ item }">
              <div v-show="item.publico == false">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                    >fa-solid fa-lock</v-icon>
                  </template>
                  <span>Documento privado</span>
                </v-tooltip>
              </div>
            </template>            
            <template v-slot:[`item.fechacreacion`]="{ item }">{{formato(item.fechacreacion)}}</template>
            <template v-slot:[`item.fechacorte`]="{ item }">{{formato(item.fechacorte)}}</template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
                
                <v-tooltip top v-if="permisovalidador">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                      @click="changestatesoporte(item)"
                    >edit</v-icon>
                  </template>
                  <span>Cambiar privacidad</span>
                </v-tooltip>

              </template>

            </v-data-table>

            
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title class="grey lighten-4 change-font">Soportes - Avance cualitativo</v-card-title>

          <v-card-text>
            <br />
            <v-data-table
              :headers="showHeadersSCuali"
              :items="gsoportescualitativosOK"
              class="elevation-1"
              :items-per-page="5"
              :no-data-text="gnodata"
            >
            <template v-slot:[`item.publico`]="{ item }">
              <div v-show="item.publico == false">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                    >fa-solid fa-lock</v-icon>
                  </template>
                  <span>Documento privado</span>
                </v-tooltip>
              </div>
            </template>            
            <template v-slot:[`item.fechacreacion`]="{ item }">{{formato(item.fechacreacion)}}</template>
            <template v-slot:[`item.fechacorte`]="{ item }">{{formato(item.fechacorte)}}</template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>

                <v-tooltip top v-if="permisovalidador">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                      @click="changestatesoporte(item)"
                    >edit</v-icon>
                  </template>
                  <span>Cambiar privacidad</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-card v-show="usuarioautenticado == true">
          <v-card-title class="grey lighten-4 change-font">Soportes - Hito</v-card-title>

          <v-card-text>
            <br />
            <v-data-table
              :headers="headersoporte"
              :items="gsoportehitoOK"
              class="elevation-1"
              :items-per-page="5"
              :no-data-text="gnodata"
            >
            <template v-slot:[`item.fechacreacion`]="{ item }">{{formato(item.fechacreacion)}}</template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
              </template>
            </v-data-table>

          </v-card-text>
        </v-card>


        <v-card>
          <v-card-title class="grey lighten-4 change-font">Soportes - Desagregaciones</v-card-title>

          <v-card-text>
            <br />
            <v-data-table
              :headers="headersoportecualitativotipovalor"
              :items="gsoporteDesagregacion"
              class="elevation-1"
              :items-per-page="5"
              :no-data-text="gnodata"
            >
            <template v-slot:[`item.publico`]="{ item }">
              <div v-show="item.publico == false">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      class="mr-2"
                    >fa-solid fa-lock</v-icon>
                  </template>
                  <span>Documento privado</span>
                </v-tooltip>
              </div>
            </template>            
            <template v-slot:[`item.fechacreacion`]="{ item }">{{formato(item.fechacreacion)}}</template>
            <template v-slot:[`item.fechacorte`]="{ item }">{{formato(item.fechacorte)}}</template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>

              </template>

            </v-data-table>

            
          </v-card-text>
        </v-card>        

      </v-tab-item>
      <!-- <v-tab-item>
        
      </v-tab-item> -->
    </v-tabs>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="cerraralert">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>      


<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import htmlToPdfmake from "html-to-pdfmake"
am4core.useTheme(am4themes_animated);
import store from "../../stores/index.js";
import _ from 'lodash';
export default {
  name: "detalle",
  data() {
    return {
      idrol: 0,
      permisovalidador: false,
      loading: false,
      cargando: false,
      clasificacionetnico: false,
      valPunto: null,
      visualizacion: 3,
      ultimoavance: null,
      idindicador: null,
      usuarioautenticado: false,
      dialog: false,
      path: process.env.BASE_URL,
      chart: undefined,
      territorializaciontexto: "",
      responsablepmitexto: "",
      territorializacionselect: [],
      entidadselected: [],
      responsableselected: [],
      unidad: "",
      periodicidad: "",
      tipoacumulacion: "",
      tipoindicador: "",
      avancegestion: 0,
      gsoportescuantitativosOK:[],
      gsoportescualitativosOK:[],
      gsoportehitoOK: [],
      headermetas: [
        { text: "Año", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" }
      ],
      headermetasCuatrenio: [
        { text: "Periodo", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" }
      ],      
      HeaderHitos: [
        {
          text: "Descripción",
          value: "descripcion",
          align: "justify",
          width: "50%"
        },
        {
          text: "Ponderación (%)",
          value: "ponderacion",
          align: "center",
          width: "20%"
        },
        {
          text: "Fecha estimada de cumplimiento",
          value: "fechacumplimiento",
          align: "center",
          width: "20%"
        },
        { text: "Cumplido", value: "cumplido", sortable: false, width: 100 }
        ,
        // { text: "Fecha de cumplimiento", value: "fechamodificacion", sortable: false, width: 100 }
        // ,
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ],
      botones: [
        {
          caption: "Por periodo",
          state: false,
          id: 2,
          color: "secondary",
          reduce: "C",
          tool: "Corresponde los indicadores vigentes por cada cuatrienio"
        },
        {
          caption: "Por vigencia",
          state: false,
          id: 3,
          color: "secondary",
          reduce: "V",
          tool: "Corresponde a los indicadores vigentes en cada año"
        }
      ],
      expanded: [],
      metasvigencia: [],
      MetasVigenciasinext: [],
      MetasCuatrenio: [],
      MetasCuatrenioext: [],
      MetasVigenciaext: [],
      singleExpand: true,
      headers: [
        { text: "Año", align: "left", sortable: false, value: "periodo", width: "50px" },
        { sortable: false, text: "Meta", value: "valor", width: "50px" },
        { sortable: false, value: "extemporaneo", width: "10px"},
        { sortable: false, text: "Avance cuantitativo", value: "reporte" },
        { sortable: false, text: "Porcentaje de avance (%)", value: "avancetexto"},
        
      ],
      subheaders: [
        {
          text: "Rango",
          align: "left",
          sortable: false,
          value: "rangoperiodo",
          width: "300px"
        },
        { sortable: false, text: "Meta", value: "valor", width: "5%" },
        {
          sortable: false,
          text: "Avance cuantitativo",
          value: "reporte",
          width: "5%"
        },
        {
          sortable: false,
          text: "Porcentaje de avance (%)",
          value: "avancetexto",
          width: "5%"
        }
      ],
      //errores
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],

      // elementos de los soportes
      headersoportecuantitativo: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        { text: "Avance", value: "rangosoporte", align: "left", width: 200 },
        { text: "Corte", value: "fechacorte", align: "left", width: 100 },
        { text: "Privado", value: "publico", align: "center", width: 120 },
        { text: "Acciones", value: "action", sortable: false, width: 130 }
      ],

      headersoportecualitativo: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        { text: "Avance", value: "rangosoporte", align: "left", width: 200 },
        { text: "Corte", value: "fechacorte", align: "left", width: 100 },
        { text: "Privado", value: "publico", align: "center", width: 120 },
        { text: "Acciones", value: "action", sortable: false, width: 130 }
      ],

      headersoportecualitativotipovalor: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        { text: "Avance", value: "rangosoporte", align: "left", width: 200 },
        { text: "Corte", value: "fechacorte", align: "left", width: 100 },
        { text: "Acciones", value: "action", sortable: false, width: 130 }
      ],      

      headersoporte: [
        { text: "Nombre archivo", value: "nombrearchivo", align: "left" },
        { text: "Fecha de carga", value: "fechacreacion", align: "left" },
        {
          text: "Cumplimiento",
          value: "rangosoporte",
          align: "center",
          width: 200
        },
        { text: "Acciones", value: "action", sortable: false, width: 130 }
      ],

      verhitos: false,
      tienerezago: false,
      indicadorfinalizado: false,
    };
  },
  methods: {
    ...mapActions([
      "metascuatrenio",
      "get_metasvigencia",
      "get_metasvigenciaExt",
      "get_metascuatrenioExt",
      "Indicador_Encabezado",
      "get_unidades",
      "getcualitativohistorico",
      "Getperiodicidad",
      "Gettipoacumulacion",
      "getcuantitativohistorico",
      "get_TipoIndicador",
      "get_territorializaciones",
      "Getentidad",
      "getsoportescuantitativos",
      "getsoportescualitativos",
      "getsoportesHitosbyind",
      "downloadsoporte",
      "Gethitos",
      "RecalcularMeta",
      "getcambiarestadosoporte",
      "getsoportescualitativostipovalor"
    ]),
    ...mapActions("usuario/", ["get_permisovalidador"]),
    verdetallehito(item) {
      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      let cifra = this.$aes.encrypt(item.idhito.toString());
      let temporal =
        Math.random()
          .toString(36)
          .substring(2, 6) +
        cifra +
        Math.random()
          .toString(36)
          .substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detallehito/" + encrypted);

    },
    pdfavance() {
      let imagen = this.glogo;
      let indicador = this.gindicador.codigo + " " + this.gindicador.nombre;
      let fecha = this.$getFormattedDate();
      let avance = this.gavancecualitativohistoric;
      let SetRol = this.idrol;
      Promise.all([this.chart.exporting.pdfmake]).then(function(res) {
        var pdfMake = res[0];
        var doc = {
          pageSize: "Letter",
          pageOrientation: "portrait",
          pageMargins: [30, 30, 30, 30],
          content: [],
          styles: {
            header: {
              fontSize: 22,
              bold: true
            },
            anotherStyle: {
              italics: true,
              alignment: "right"
            }
          },
          footer: function(currentPage, pageCount) {
            return [
              {
                text: fecha,
                alignment: "left",
                margin: [10, 0],
                fontSize: 8
              },
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                alignment: "right",
                margin: [10, 0],
                fontSize: 8
              }
            ];
          }
        };
        doc.content.push({
          image: imagen,
          width: 150
        });
        doc.content.push({
          text: "Avance Cualitativo de Indicador",
          fontSize: 20,
          bold: true,
          margin: [0, 20, 0, 15]
        });
        doc.content.push({
          text: "Filtro: [Indicador: " + indicador + "]",
          fontSize: 12,
          bold: false,
          margin: [0, 20, 0, 15]
        });
        var index = 0;
        for (index = 0; index < avance.length; index++) {
          doc.content.push({
            text: moment(String(avance[index].fechacorte)).format("DD/MM/YYYY"),
            fontSize: 12,
            bold: true,
            margin: [0, 20, 0, 15]
          });

          if (SetRol == 1 || SetRol == 2 || SetRol == 3){
            if (avance[index].principalavance != null) {
              doc.content.push({
              text: "Principales avances en función del cumplimiento de la meta del indicador",
              fontSize: 12,
              bold: true,
              margin: [0, 20, 0, 15]
            });

              doc.content.push({
                text: htmlToPdfmake(avance[index].principalavance),
                fontSize: 11,
                margin: [0, 20, 0, 15],
                color: "#636363",
                alignment: "justify"
              });
            } 
          }          

          doc.content.push({
          text: "Justificación del avance",
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 15]
        });

          doc.content.push({
            text: htmlToPdfmake(avance[index].descripcion),
            fontSize: 11,
            margin: [0, 20, 0, 15],
            color: "#636363",
            alignment: "justify"
          });


      if (SetRol == 1 || SetRol == 2 || SetRol == 3){
       

        if (avance[index].avancesReestricciones.length > 0  ) {
            doc.content.push({
            text: "Restricciones",
            fontSize: 12,
            bold: true,
            margin: [0, 20, 0, 15]
            });
//<div style="display: inline;" v-if="item1.nombreRestriccion == 'Otra'">({{ item.nuevareestriccion }})</div>
          avance[index].avancesReestricciones.forEach(element => {  
            
            if (element.nombreRestriccion == "Otra") {
              doc.content.push({
              text: "* " + element.nombreRestriccion + "( " + avance[index].nuevareestriccion + " )" ,
              fontSize: 11,
              color: "#636363",
              margin: [0, 20, 0, 15]
              });
            } else {
              doc.content.push({
              text: "* " + element.nombreRestriccion,
              fontSize: 11,
              color: "#636363",
              margin: [0, 20, 0, 15]
              });              
            }

          });
        }

        if (avance[index].cuellobotella != null) {
          doc.content.push({
          text: "Cuellos de botella y limitaciones que afectaron el desempeño del indicador",
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 15]
        });

          doc.content.push({
            text: htmlToPdfmake(avance[index].cuellobotella),
            fontSize: 11,
            margin: [0, 20, 0, 15],
            color: "#636363",
            alignment: "justify"
          });
        }
        }

        }
        pdfMake.createPdf(doc).download("cualitativo.pdf");
      });
    },
    pdfficha() {
      let imagen = this.glogo;      
      let indicador = this.gindicador.codigo + " " + this.gindicador.nombre;
      let fecha = this.$getFormattedDate();
      let valPunto = this.valPunto;
      let ttitulo = 8;
      let ttexto = 10;
      let periodicidad = this.periodicidad;
      let unidad = this.unidad;
      let mvigencia = this.gmetasvigencia;
      let mperiodo = this.gmetascuatrenio;
      let tipoacumulacion = this.tipoacumulacion;
      let tipoindicador = this.tipoindicador;
      let territorialindicador =
        valPunto.territorialindicador === true ? "Sí" : "No";
      let desagregacionpoblacional =
        valPunto.desagregacionpoblacional === true ? "Sí" : "No";
      let pertenenciaetnica = valPunto.pertenenciaetnica === true ? "Sí" : "No";
      let territorializaciontexto = this.territorializaciontexto;
      let responsablepmitexto = this.responsablepmitexto;
      let clasificacionetnico = this.clasificacionetnico;
      Promise.all([this.chart.exporting.pdfmake]).then(function(res) {
        var pdfMake = res[0];
        function buildTableBody(data, columns, mostrar) {
          var body = [];
          body.push(mostrar);
          data.forEach(function(row) {
            var dataRow = [];
            columns.forEach(function(column) {
              var texto = "";
              if (row[column] !== null && row[column] !== undefined) {
                texto = Intl.NumberFormat("es-CO", {
                  minimumFractionDigits: 1
                }).format(row[column]);
              }
              if (column === "periodo") {
                dataRow.push({
                  text: row[column],

                  fontSize: ttexto
                });
                dataRow.push();
              } else
                dataRow.push({
                  text: texto,
                  alignment: "right",
                  fontSize: ttexto
                });
            });
            body.push(dataRow);
          });
          return body;
        }

        function table(fuente) {
          var data = fuente;
          var columns = ["periodo", "valor"];
          var mostrar = ["Periodo", "Meta"];
          return {
            table: {
              headerRows: 1,
              width: "200",
              widths: ["70%", "30%"],
              body: buildTableBody(data, columns, mostrar)
            },
            layout: pdfMake.tableLayouts.exampleLayout
          };
        }
        pdfMake = res[0];
        pdfMake.tableLayouts = {
          exampleLayout: {
            hLineWidth: function(i, node) {
              if (i === 0 || i === node.table.body.length) {
                return 0;
              }
              return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function() {
              return 0;
            },
            hLineColor: function(i) {
              return i === 1 ? "green" : "#aaa";
            },
            paddingLeft: function(i) {
              return i === 0 ? 0 : 8;
            },
            paddingRight: function(i, node) {
              return i === node.table.widths.length - 1 ? 0 : 8;
            },
            fillColor: function(i) {
              return i === 0 ? "#f5f5f5" : "white";
            }
          }
        };
        // pdfmake is ready
        // Create document template
        var doc = {
          pageSize: "Letter",
          pageOrientation: "portrait",
          pageMargins: [30, 80, 30, 30],
          content: [],
          styles: {
            header: {
              bold: true
            },
            anotherStyle: {
              italics: true,
              alignment: "justify"
            }
          },
          header: function() {
            return {
              image: imagen,
              width: 150,
              margin: [30, 30, 50, 50]
            };
          },
          footer: function(currentPage, pageCount) {
            return [
              {
                text: fecha,
                alignment: "left",
                margin: [10, 0],
                fontSize: 8
              },
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                alignment: "right",
                margin: [10, 0],
                fontSize: 8
              }
            ];
          }
        };

        doc.content.push({
          text: "Ficha de Indicador PMI",
          fontSize: 20,
          bold: true,
          margin: [0, 20, 0, 15]
        });
        doc.content.push({
          text: indicador,
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 15]
        });
        doc.content.push({
          text: "Punto:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.punto.nombre,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          text: "Pilar:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.pilar.nombrecompleto,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          text: "Estrategia:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.estrategia.nombrecompleto,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          text: "Línea de acción:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.linea.nombrecompleto,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          text: "Producto:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.idproductoNavigation.nombrecompleto,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          columns: [
            {
              text: "Inicio:",
              width: 250,
              fontSize: ttitulo,
              bold: true
            },
            { text: "Fin:", fontSize: ttitulo, bold: true, width: 250 }
          ]
        });

        doc.content.push({
          columns: [
            {
              text: valPunto.inicio,
              width: 250,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              margin: [0, 0, 0, 15]
            },
            {
              text: valPunto.fin,
              bold: false,
              fontSize: ttexto,
              alignment: "justify",
              margin: [0, 0, 0, 15],
              width: 250
            }
          ]
        });

        doc.content.push({ text: "Sector:", fontSize: ttitulo, bold: true });
        doc.content.push({
          text: valPunto.sectores.nombre,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Entidad responsable:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.entidades.nombre,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Clasificador PMI:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.idclasificacionNavigation.nombre,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Descripción:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.descripcion,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Fórmula de cálculo:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.formulacalculo,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          columns: [
            {
              text: "Unidad de medida:",
              width: 170,
              fontSize: ttitulo,
              bold: true
            },
            {
              text: "Periodicidad de actualización:",
              fontSize: ttitulo,
              bold: true,
              width: 170
            },
            {
              text: "Días de rezago:",
              fontSize: ttitulo,
              bold: true,
              width: 170
            }
          ]
        });
        doc.content.push({
          columns: [
            {
              text: unidad,
              width: 170,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              margin: [0, 0, 0, 15]
            },
            {
              text: periodicidad,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              width: 170
            },
            {
              text: valPunto.diasrezago,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              width: 170
            }
          ]
        });

        doc.content.push({
          text: "Metodología de medición:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.metodologiamedicion,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        if (valPunto.lineabase === null) {
          doc.content.push({
            text: "Argumento de porque no tiene línea base:",
            fontSize: ttitulo,
            bold: true
          });
          doc.content.push({
            text: valPunto.comentariolineabase,
            fontSize: ttexto,
            alignment: "justify",
            bold: false,
            margin: [0, 0, 0, 15]
          });
        } else {
          doc.content.push({
            columns: [
              {
                text: "Línea base:",
                width: 250,
                fontSize: ttitulo,
                bold: true
              },
              {
                text: "Fecha de línea base:",
                fontSize: ttitulo,
                bold: true,
                width: 250
              }
            ]
          });

          doc.content.push({
            columns: [
              {
                text: valPunto.lineabase,
                width: 250,
                fontSize: ttexto,
                alignment: "justify",
                bold: false,
                margin: [0, 0, 0, 15]
              },
              {
                text: moment(String(valPunto.fechabase)).format("DD/MM/YYYY"),
                bold: false,
                fontSize: ttexto,
                alignment: "justify",
                margin: [0, 0, 0, 15],
                width: 250
              }
            ]
          });
        }

        doc.content.push({
          text: "",
          fontSize: ttitulo,
          bold: true,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          columns: [
            {
              text: "Metas por vigencia:",
              fontSize: ttitulo,
              width: 120
            },
            table(mvigencia),
            {
              text: "",
              width: 120
            }
          ],
          columnGap: 30
        });

        doc.content.push({
          text: "",
          fontSize: ttitulo,
          bold: true,
          margin: [0, 0, 0, 15]
        });
        doc.content.push({
          columns: [
            {
              text: "Metas por periodo:",
              fontSize: ttitulo,
              width: 120
            },
            table(mperiodo),
            {
              text: "",
              width: 120
            }
          ],
          columnGap: 30
        });

        doc.content.push({
          text: "Meta global:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.meta,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          columns: [
            {
              text: "Tipo de acumulación:",
              width: 250,
              fontSize: ttitulo,
              bold: true
            },
            {
              text: "Tipo de indicador:",
              fontSize: ttitulo,
              bold: true,
              width: 250
            }
          ]
        });

        doc.content.push({
          columns: [
            {
              text: tipoacumulacion,
              width: 250,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              margin: [0, 0, 0, 15]
            },
            {
              text: tipoindicador,
              bold: false,
              fontSize: ttexto,
              alignment: "justify",
              margin: [0, 0, 0, 15],
              width: 250
            }
          ]
        });

        doc.content.push({
          columns: [
            {
              text: "Territorialización de indicador:",
              width: 170,
              fontSize: ttitulo,
              bold: true
            },
            {
              text: "Desagregación poblacional por sexo:",
              fontSize: ttitulo,
              bold: true,
              width: 170
            },
            {
              text: "Pertenencia étnica:",
              fontSize: ttitulo,
              bold: true,
              width: 170
            }
          ]
        });
        doc.content.push({
          columns: [
            {
              text: territorialindicador,
              width: 170,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              margin: [0, 0, 0, 15]
            },
            {
              text: desagregacionpoblacional,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              width: 170
            },
            {
              text: pertenenciaetnica,
              fontSize: ttexto,
              alignment: "justify",
              bold: false,
              width: 170
            }
          ]
        });
        if (valPunto.territorialindicador) {
          doc.content.push({
            text: "Territorialización:",
            fontSize: ttitulo,
            bold: true
          });
          doc.content.push({
            text: territorializaciontexto,
            fontSize: ttexto,
            alignment: "justify",
            bold: false,
            margin: [0, 0, 0, 15]
          });
        }

        doc.content.push({
          text: "Fuentes de información:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.fuenteinformacion,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Responsable PMI:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: responsablepmitexto,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });

        doc.content.push({
          text: "Observaciones:",
          fontSize: ttitulo,
          bold: true
        });
        doc.content.push({
          text: valPunto.observacionadicional,
          fontSize: ttexto,
          alignment: "justify",
          bold: false,
          margin: [0, 0, 0, 15]
        });
        if (clasificacionetnico) {
          doc.content.push({
            text: "Metas trazadoras:",
            fontSize: ttitulo,
            bold: true
          });
          doc.content.push({
            text: valPunto.metastrazadoras,
            fontSize: ttexto,
            alignment: "justify",
            bold: false,
            margin: [0, 0, 0, 15]
          });

          doc.content.push({
            text: "Observaciones étnico:",
            fontSize: ttitulo,
            bold: true
          });
          doc.content.push({
            text: valPunto.observacionetnicos,
            fontSize: ttexto,
            alignment: "justify",
            bold: false,
            margin: [0, 0, 0, 15]
          });
        }
        pdfMake.createPdf(doc).download("ficha.pdf");
      });
    },
    pdfcomparativo() {
      let imagen = this.glogo;
      let indicador = this.gindicador.codigo + " " + this.gindicador.nombre;
      let avance = this.metasvigencia;
      let fecha = this.$getFormattedDate();
      Promise.all([
        this.chart.exporting.pdfmake,
        this.chart.exporting.getImage("png")
      ]).then(function(res) {
        function buildTableBody(data, columns, mostrar) {
          var body = [];
          body.push(mostrar);
          data.forEach(function(row) {
            var dataRow = [];
            columns.forEach(function(column) {
              var texto = "";
              if (row[column] !== null && row[column] !== undefined) {
                texto = Intl.NumberFormat("es-CO", {
                  minimumFractionDigits: 1
                }).format(row[column]);
              }
              if (column === "periodo") dataRow.push(row[column]);
              else
                dataRow.push({
                  text: texto,
                  alignment: "right"
                });
            });
            body.push(dataRow);
          });
          return body;
        }

        function table() {
          var data = avance;
          var columns = ["periodo", "valor", "reporte", "avance"];
          var mostrar = ["Año", "Meta", "Avance", "Porcentaje de avance"];
          return {
            table: {
              headerRows: 1,
              width: "250",
              widths: ["15%", "25%", "25%", "35%"],
              body: buildTableBody(data, columns, mostrar)
            },
            layout: pdfMake.tableLayouts.exampleLayout
          };
        }
        var pdfMake = res[0];
        pdfMake.tableLayouts = {
          exampleLayout: {
            hLineWidth: function(i, node) {
              if (i === 0 || i === node.table.body.length) {
                return 0;
              }
              return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function() {
              return 0;
            },
            hLineColor: function(i) {
              return i === 1 ? "green" : "#aaa";
            },
            paddingLeft: function(i) {
              return i === 0 ? 0 : 8;
            },
            paddingRight: function(i, node) {
              return i === node.table.widths.length - 1 ? 0 : 8;
            },
            color: "#453467",
            fontSize: 8,
            fillColor: function(i) {
              return i === 0 ? "#f5f5f5" : "white";
            }
          }
        };
        // pdfmake is ready
        // Create document template
        var doc = {
          pageSize: "Letter",
          pageOrientation: "portrait",
          pageMargins: [30, 30, 30, 30],
          content: [],
          styles: {
            header: {
              fontSize: 22,
              bold: true
            },
            anotherStyle: {
              italics: true,
              alignment: "right"
            }
          },
          footer: function(currentPage, pageCount) {
            return [
              {
                text: fecha,
                alignment: "left",
                margin: [10, 0],
                fontSize: 8
              },
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                alignment: "right",
                margin: [10, 0],
                fontSize: 8
              }
            ];
          }
        };
        doc.content.push({
          image: imagen,
          width: 150
        });
        doc.content.push({
          text: "Detalle de Avance de Indicador",
          fontSize: 20,
          bold: true,
          margin: [0, 20, 0, 15]
        });
        doc.content.push({
          text: "Filtro: [Indicador: " + indicador + "]",
          fontSize: 12,
          bold: false,
          margin: [0, 20, 0, 15]
        });
        doc.content.push({
          image: res[1],
          width: 530
        });
        doc.content.push({
          text: "",
          fontSize: 20,
          bold: true,
          margin: [0, 20, 0, 15]
        });

        doc.content.push({
          columns: [
            {
              text: "",
              width: 50
            },
            table(),
            {
              text: "",
              width: 50
            }
          ],
          columnGap: 30
        });
        pdfMake.createPdf(doc).download("report.pdf");
      });
    },
    usuario() {
      let Getusuario = undefined;
      if (localStorage.usuario != undefined)
        Getusuario = JSON.parse(unescape(localStorage.usuario))
      return Getusuario;
    },
    recalcularMetas() {
      let GetUsuario = undefined;
      if (localStorage.usuario != undefined)
        GetUsuario = this.usuario();

      if (GetUsuario != undefined){
        let GetIdUsuario = GetUsuario.idusuario
        this.loading = true;
        this.RecalcularMeta({
          data: this.gindicador,
          params: {
            idusuario: GetIdUsuario
          }
        });
      } 
    },
    cambiardecimal(valor) {
      return Intl.NumberFormat("es-CO", { minimumFractionDigits: 1 }).format(
        valor
      );
    },
    tieneAvance(avances) {
      let avance = _.filter(avances, {'ultimo': true, 'idestado': 6});
      return avance.length > 0 && _.head(avance).reporte != null;
    },
    creargrafico() {
      // Create chart instance
      this.chart = am4core.create("chartdiv", am4charts.XYChart);
      this.chart.language.locale["_decimalSeparator"] = ",";
      this.chart.language.locale["_thousandSeparator"] = ".";
      let dataChar = [];
      if (this.visualizacion === 3)
        dataChar = this.gmetasvigenciavencidawithext;

      else dataChar = this.gmetascuatrenioavance;

      // 
      var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;

      // Create axes
      var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.data = dataChar;
      categoryAxis.dataFields.category = "periodo";
      var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      if (this.gindicador.idunidad != null)
        valueAxis.title.text = this.gunidades.filter(p => p.idunidad === this.gindicador.idunidad )[0].nombre;


      //Create series
      var series2 = this.chart.series.push(new am4charts.ColumnSeries());
      series2.data = dataChar.filter(p=> p.extemporaneo == false);
      series2.name = "Avance";
      series2.dataFields.valueY = "reporte";
      series2.dataFields.categoryX = "periodo";
      series2.dataFields.valueX = "avancereal";
      
      series2.tooltipText = "{name}: [bold]{valueY}[/]; Porcentaje: [bold]{valueX}%";
      // series2.columns.template.fill = "{colorcolumn}";
      // series2.columns.template.stroke = "{colorcolumn}";    
      series2.columns.template.fill = am4core.color("#009DE1");
      series2.columns.template.stroke = am4core.color("#009DE1");
      //series2.stacked = true;
      series2.clustered = false;
      

      // Add serie extemporaneo
      if (dataChar.filter(p=> p.extemporaneo == true && p.ultimoext == true).length > 0)
      {
        var series3 = this.chart.series.push(new am4charts.ColumnSeries());
        if (this.visualizacion === 3)
          series3.data = dataChar.filter(p=> p.extemporaneo == true && p.ultimoext == true);
        else 
          series3.data = dataChar.filter(p=> p.extemporaneo == true);

        if (this.tienerezago && this.indicadorfinalizado == false)
          series3.name = "Avance rezagado";
        else
          series3.name = "Posterior a vigencia PMI";
        series3.dataFields.valueY = "reporte";
        series3.dataFields.categoryX = "periodo";
        series3.dataFields.valueX = "avancereal";
        series3.tooltipText = "{name}: [bold]{valueY}[/]; Porcentaje: [bold]{valueX}%";   
        series3.columns.template.fill = am4core.color("#9BBAE3");
        series3.columns.template.stroke = am4core.color("#9BBAE3"); 
        series3.clustered = false;
        //series3.stacked = true;           
      
      }

      var series = this.chart.series.push(new am4charts.LineSeries());
      series.data = dataChar;
      series.name = "Meta";
      series.dataFields.valueY = "valor";
      series.dataFields.valueX = "avancereal";
      series.dataFields.categoryX = "periodo";
      series.name = "Meta";
      series.stroke = am4core.color("#B4CC1E");
      series.strokeWidth = 3;
      series.propertyFields.strokeDasharray = "lineDash";
      series.tooltip.label.textAlign = "middle";
      series.tooltipText = "{name}: [bold]{valueY}[/]";
      

      var bullet = series.bullets.push(new am4charts.Bullet());
      bullet.fill = am4core.color("#000"); // tooltips grab fill from parent by default
      //bullet.tooltipText = "[#fff font-size: 12px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      var circle = bullet.createChild(am4core.Circle);
      circle.radius = 4;
      circle.fill = am4core.color("#000");
      circle.strokeWidth = 3;
      var labelBullet = new am4charts.LabelBullet();
      series.bullets.push(labelBullet);
      labelBullet.label.fontSize = 10;
      labelBullet.strokeOpacity = 0;
      labelBullet.dy = -10;
      var title = this.chart.titles.create();
      title.text = "Avance cuantitativo del indicador VS la meta (" + this.gcomparativa.filter(p => p.id === this.visualizacion)[0].caption + ")";
      title.fontSize = 20;
      title.marginBottom = 30;
      this.chart.legend = new am4charts.Legend();
      // Add cursor
      this.chart.cursor = new am4charts.XYCursor();
      var label = this.chart.createChild(am4core.Label);
      label.text =
        "Fecha de actualización: " +
        this.formato(this.gindicador.fechamodificacion);
      label.fontSize = 11;
      label.align = "right";
      let ultima = this.gultimameta;
      if (ultima !== "") {
        var corte = this.chart.createChild(am4core.Label);
        corte.text = "Fecha de corte: " + this.formato(ultima);
        corte.fontSize = 11;
        corte.align = "right";
      }

    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    calcularunidad() {
      if (this.gunidades !== undefined) {
        if (this.gindicador.idunidad != null)
        this.unidad = this.gunidades.filter(
          p => p.idunidad === this.gindicador.idunidad
        )[0].nombre;
      } else {
        store.watch(
          () => store.getters["gunidades"],
          () => {
            this.unidad = this.gunidades.filter(
              p => p.idunidad === this.gindicador.idunidad
            )[0].nombre;
          }
        );
      }
    },
    calcularperiodicidad() {
      if (this.gindicador.idperiodicidadactualizacion !== null) {
        if (this.gperiodicidad.length > 0) {
          this.periodicidad = this.gperiodicidad.filter(
            p =>
              p.idperiodicidad === this.gindicador.idperiodicidadactualizacion
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gperiodicidad"],
            () => {
              this.periodicidad = this.gperiodicidad.filter(
                p =>
                  p.idperiodicidad ===
                  this.gindicador.idperiodicidadactualizacion
              )[0].nombre;
            }
          );
        }
      }
    },
    calculartipoacumulacion() {
      if (this.gindicador.idtipoacumulacion !== null) {
        if (this.gtipoacumulacion.length > 0) {
          this.tipoacumulacion = this.gtipoacumulacion.filter(
            p => p.idtipoacumulacion === this.gindicador.idtipoacumulacion
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gtipoacumulacion"],
            () => {
              this.tipoacumulacion = this.gtipoacumulacion.filter(
                p => p.idtipoacumulacion === this.gindicador.idtipoacumulacion
              )[0].nombre;
            }
          );
        }
      }
    },
    calculartipoindicador() {
      if (this.gindicador.idtipoindicador !== null) {
        if (this.gtiposindicador.length > 0) {
          this.tipoindicador = this.gtiposindicador.filter(
            p => p.idtipoindicador === this.gindicador.idtipoindicador
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gtiposindicador"],
            () => {
              this.tipoindicador = this.gtiposindicador.filter(
                p => p.idtipoindicador === this.gindicador.idtipoindicador
              )[0].nombre;
            }
          );
        }
      }
    },
    calcularresponsable() {
      if (this.gindicador.identidadresponsablepmi != undefined) {
        if (this.gentidades !== undefined) {
          this.entidadresponsablepmi = this.gentidades.filter(
            p => p.identidad === this.gindicador.identidadresponsablepmi
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gentidades"],
            () => {
              this.entidadresponsablepmi = this.gentidades.filter(
                p => p.identidad === this.gindicador.identidadresponsablepmi
              )[0].nombre;
            }
          );
        }
      }
    },
    descargarsoporte(item) {
      this.downloadsoporte({
        params: {
          idindicador: this.valPunto.idindicador,
          idsoporte: item.idsoporte
        }
      });
    },
    cerraralert(){
      this.snack = false
      this.$router.go()
    },
    row_classes(item) {
        if (item.extemporaneo == true) {
          return "blue-grey";
        } 
    },
    changestatesoporte(item){
      this.getcambiarestadosoporte({ params: { idsoporte: item.idsoporte } });
      if (item.publico == false)
        item.publico = true;
      else
        item.publico = false;
    }

  },
  created() {
    this.cargando = true;
    this.get_unidades();
    this.get_TipoIndicador();
    this.get_territorializaciones();
    this.Getentidad();
    let getUser = this.usuario();
    if (getUser != undefined)
    {
      if (getUser.usuarioRol.length > 0)
        this.idrol = getUser.usuarioRol[0].idrol
    }
    let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
    let env = global[global.env];
    this.$aes.setKey(env.path.secret);
    let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    this.idindicador = temporal;
    this.getcuantitativohistorico({
      params: {
        idindicador: temporal
      }
    });
    this.Gethitos({
      params: {
        idindicador: this.idindicador
      }
    });
    this.Indicador_Encabezado({
      params: {
        idindicador: this.idindicador
      }
    });
    this.get_metascuatrenioExt({
      params: {
        idindicador: this.idindicador
      }
    });
    this.get_metasvigenciaExt({
      params: {
        idindicador: this.idindicador
      }
    });
    this.metascuatrenio({
      params: {
        idindicador: this.idindicador
      }
    });    
    this.get_metasvigencia({
      params: {
        idindicador: this.idindicador
      }      
    })
    this.getcualitativohistorico({
      params: {
        idindicador: this.idindicador
      }
    });
    this.Getperiodicidad();
    this.Gettipoacumulacion();
    this.usuarioautenticado = localStorage.usuario !== undefined;
    
  },
  mounted() {},
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  computed: {
    ...mapGetters([
      "gmetascuatrenioavance",
      "gmetasvigenciaconavance",
      "gmetasvigenciavencidawithext",
      "gmetascuatrenio",
      "gmetasvigencia",
      "gmetasvigenciavisibles",
      "gmetasvigenciasinext",
      "gmetascuatreniosinext",
      "gmetasvigenciaext",
      "gmetascuatrenioext",
      "gindicador",
      "gunidades",
      "gavancecualitativohistoric",
      "gperiodicidad",
      "gtipoacumulacion",
      "gavancecuantitativohistoric",
      "gtiposindicador",
      "gterritorializaciones",
      "gentidades",
      "gultimameta",
      "gsoportescuantitativosaprobados",
      "gsoportescualitativosaprobados",
      "gsoportehitoaprobados",
      "ghito",
      "gopciones",
      "gsoporteDesagregacion"
    ]),
    ...mapGetters("barra", ["gcomparativa"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo", "glogodnp"]),
    ...mapGetters("usuario", ["gpermisovalidador"]),

    showHeadersSCuanti () {
      return this.headersoportecuantitativo.filter(s => {
          if (s.value == 'publico')
          {
            if (this.usuarioautenticado == true)
            return s;
          }
          else 
            return s;
        });
    },
    showHeadersSCuali () {
      return this.headersoportecualitativo.filter(s => {
          if (s.value == 'publico')
          {
            if (this.usuarioautenticado == true)
            return s;
          }
          else 
            return s;
        });
    }    
  },
  watch: {
    gmetasvigenciaconavance: function() {
      // if (this.gindicador) this.creargrafico();
    },
    gmetasvigenciavisibles: function() {
      this.metasvigencia = this.gmetasvigenciavisibles.filter(p=>  p.idestado == 6 );
      this.gmetasvigenciavisibles.forEach(element => {
        if (element.extemporaneo == true)
          element.avanceCuantitativo.forEach(subelement => {
            if ( subelement.estado != 6)
              this.tienerezago = true; 
          });
      });
      if (this.gindicador) this.creargrafico();     
    },
    gmetasvigenciasinext: function () {
      this.MetasVigenciasinext = this.gmetasvigenciasinext;
    },
    gmetasvigenciaext: function () {
      this.MetasVigenciaext = this.gmetasvigenciaext;
    },
    gmetascuatreniosinext: function () {
      this.MetasCuatrenio = this.gmetascuatreniosinext;
    },
    gmetascuatrenioext: function () {
      this.MetasCuatrenioext = this.gmetascuatrenioext;
    },            
    gindicador: function() {
      if (this.gindicador.codigo != undefined)
      {
        if (this.gindicador.gestioncerrada != null)
          if (this.gindicador.gestioncerrada == true)
            this.indicadorfinalizado = true;
        this.valPunto = this.gindicador;
        this.cargando = false;
        this.valPunto.indicadorTerritorializaciones.forEach(element => {
          this.territorializacionselect.push(element.idterritorializacion);
          let nombre = this.gterritorializaciones.filter(
            p => p.idterritorializacion == element.idterritorializacion
          )[0].nombre;
          this.territorializaciontexto =
            this.territorializaciontexto +
            (this.territorializaciontexto === "" ? "" : ", ") +
            nombre;
        });
        this.valPunto.indicadorEntidades.forEach(element => {
          this.entidadselected.push(element.identidad);
        });
        this.valPunto.indicadorResponsable.forEach(element => {
          this.responsableselected.push(element.identidad);
          let filterentidad = this.gentidades.filter(p => p.identidad == element.identidad );
          let nombre = '';
          console.log('filterentidad', filterentidad)
          if (filterentidad != undefined)
            if (filterentidad[0].nombre != undefined)
              nombre = filterentidad[0].nombre;
          this.responsablepmitexto = this.responsablepmitexto + (this.responsablepmitexto === "" ? "" : ", ") + nombre;
        });
        if (this.metasvigencia) this.creargrafico();
        this.calcularunidad();
        this.calcularperiodicidad();
        this.calculartipoacumulacion();
        this.calculartipoindicador();
        this.calcularresponsable();
      }
    },
    valPunto: function() {
      if (this.valPunto !== undefined) {
        this.getsoportescuantitativos({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });
        this.getsoportescualitativostipovalor({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });        

        let getUser = this.usuario();
        if (getUser != undefined)
        {
          if (getUser.usuarioRol.length > 0)
            this.get_permisovalidador({
              params: {
                idusuario: getUser.idusuario, idpunto: this.valPunto.idpunto
              }
            });            
        }                
        this.getsoportescualitativos({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });
        this.getsoportesHitosbyind({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });
      }
      if (this.valPunto.idclasificacionNavigation.idclasificacion === 1) {
        this.clasificacionetnico = true;
      }
    },
    visualizacion: function() {
      if (this.metasvigencia && this.gindicador) this.creargrafico();
    },
    gavancecualitativohistoric: function() {
      
      console.log('this.gavancecualitativohistoric', this.gavancecualitativohistoric)
      this.ultimoavance = this.gavancecualitativohistoric[0];
    },
    ginformation() {
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
      this.loading = false;
    },
    ghito: function(){
        
        let opcion = this.gopciones.filter(p => p.codigo === "O006-3")[0];
        if (opcion !== undefined && this.ghito.length > 0) {
          this.verhitos = true;
        }
        
        if(_.filter(this.ghito, {'idestado': 6, 'cumplido': true}).length > 0)
          this.avancegestion = _.sumBy(_.filter(this.ghito, {'idestado': 6, 'cumplido': true}), 'ponderacion') + '%';
        else
          this.avancegestion = '-';

    },
    gsoportescuantitativosaprobados: function(){
      if (this.usuarioautenticado == false)
      {
        this.gsoportescuantitativosOK = _.orderBy(this.gsoportescuantitativosaprobados.filter(p => p.publico == true), ['fechacreacion'], ['desc']);
      } else
      {
        this.gsoportescuantitativosOK = _.orderBy(this.gsoportescuantitativosaprobados, ['fechacreacion'], ['desc']);
      }
    },
    gsoportescualitativosaprobados: function(){
      if (this.usuarioautenticado == false)
      {
        this.gsoportescualitativosOK = _.orderBy(this.gsoportescualitativosaprobados.filter(p => p.publico == true), ['fechacreacion'], ['desc']);  
      } else
      {
        this.gsoportescualitativosOK = _.orderBy(this.gsoportescualitativosaprobados, ['fechacreacion'], ['desc']);
      }
      
    },
    gsoportehitoaprobados: function(){
      this.gsoportehitoOK = _.orderBy(this.gsoportehitoaprobados, ['fechacreacion'], ['desc']);
    },
    gpermisovalidador: function() {
      console.log('get_permisovalidador', this.gpermisovalidador)
      this.permisovalidador = this.gpermisovalidador;
    }
  }
};
</script>